import { render, staticRenderFns } from "./SetTimePostPinTeacherExpiration.vue?vue&type=template&id=6674f56a&scoped=true"
import script from "./SetTimePostPinTeacherExpiration.vue?vue&type=script&lang=js"
export * from "./SetTimePostPinTeacherExpiration.vue?vue&type=script&lang=js"
import style0 from "./SetTimePostPinTeacherExpiration.vue?vue&type=style&index=0&id=6674f56a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6674f56a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6674f56a')) {
      api.createRecord('6674f56a', component.options)
    } else {
      api.reload('6674f56a', component.options)
    }
    module.hot.accept("./SetTimePostPinTeacherExpiration.vue?vue&type=template&id=6674f56a&scoped=true", function () {
      api.rerender('6674f56a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notifyTeacher/SetTimePostPinTeacherExpiration.vue"
export default component.exports